import { useCallback } from 'react';

import { onContextMenuButtonClicked } from '../../../common/utils/events/context-menu-button-clicked';
import { getExtensionData } from '../../../common/utils/relay/get-extension-data';
import { useAnalytics, useCommonAndPrivateAttributes } from '../../analytics';

/**
 * @returns a callback to fire an event when the result
 * is clicked by the user.
 */
export const useFireContextMenuButtonClicked: () => () => void = () => {
	const { fireAnalyticsEvent } = useAnalytics();
	const { commonAttributes, nonPrivacySafeAttributes } = useCommonAndPrivateAttributes();

	return useCallback(() => {
		fireAnalyticsEvent(
			onContextMenuButtonClicked({
				commonAttributes: {
					...commonAttributes,
					...getExtensionData(commonAttributes.isCQL),
				},
				nonPrivacySafeAttributes,
			}),
		);
	}, [fireAnalyticsEvent, commonAttributes, nonPrivacySafeAttributes]);
};
